import { render, staticRenderFns } from "./WebsiteMenus.vue?vue&type=template&id=1dae8e85&scoped=true&"
import script from "./WebsiteMenus.vue?vue&type=script&lang=js&"
export * from "./WebsiteMenus.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteMenus.vue?vue&type=style&index=0&id=1dae8e85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dae8e85",
  null
  
)

export default component.exports